import type { HTMLComponent } from "@commercekit/react";
import classNames from "classnames";
import WvAlert from "../atoms/WvAlert";

const WvErrorAlert: HTMLComponent<{
  message: string;
  type: "warning" | "danger" | "success";
}> = ({ message, className, type, ...props }) => (
  <div
    className={classNames(
      "fixed top-0 left-1/2 z-[100001] -translate-x-1/2",
      className
    )}
    {...props}
  >
    <WvAlert type={type}>{message}</WvAlert>
  </div>
);
export default WvErrorAlert;
